export const combineKeyValue = (data: { [key: string]: [string] }[]) => {
  const result: { [key: string]: any } = {}

  data.forEach((item) => {
    Object.entries(item).forEach(([key, values]) => {
      if (!result[key]) {
        result[key] = []
      }
      values.forEach((value) => {
        const exists = result[key].find((i: any) => i === value)
        if (!exists) {
          result[key].push(value)
        }
      })
    })
  })

  return result
}
